import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserModule } from '@angular/platform-browser';
import '@angular/compiler';

import {
  Component,
  NgModule,
  OnInit,
  ViewEncapsulation,
  HostListener,
  ElementRef,
  inject,
  ViewChild,
  CUSTOM_ELEMENTS_SCHEMA
} from '@angular/core';
import { FormsModule } from '@angular/forms'
import template from '../../template-angular/comparison-editions/comparison-editions-table.html';
import { InterfaceEditorials } from '../../interface/сomparison-editions/interface.editorials';
import { InterfaceRadioEditorials } from '../../interface/сomparison-editions/interface.radio.editorials';
import { ColumnMode, DatatableComponent, NgxDatatableModule, TableColumn } from '@swimlane/ngx-datatable';
import { provideTippyLoader, provideTippyConfig, tooltipVariation, popperVariation } from '@ngneat/helipopper/config';
import { TippyDirective } from '@ngneat/helipopper';
import tippy from 'tippy.js';
import { ComparisonRow, comparisonRows } from '../../common/items/comparison-rows';
import { serverSolutionPricingItems } from  '../../common/items/server-solution-pricing';
import {numberConnections} from '../../common/consts';
import { editorialBoard } from '../../common/conformity/editorialBoard';
import { ComparisonEditionsSelectComponent } from './comparison.editions.select.component';
import { EscapeHtmlPipe } from './pipe';

@Component({
  selector: 'app-comparison-editions-table',
  standalone: false,
  template,
  /// templateUrl: './template-angular/comparison-editions/comparison-editions-table.html',
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  @ViewChild(DatatableComponent) table!: DatatableComponent;
  // @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('table', { read: ElementRef }) tableEl!: ElementRef;
  units: InterfaceEditorials[];
  unitsClone: InterfaceEditorials[];
  selectedItems: number[] = [];
  isOpen: boolean = false;
  hasOneCheckboxChecked: boolean;
  radioItems: InterfaceRadioEditorials[];
  collapsedGroups = new Set<number>();
  rows = structuredClone(comparisonRows) as ComparisonRow[];
  visibleRows = structuredClone(this.rows);
  visibleUnits: InterfaceEditorials[];
  serverSolutionPricingItems = structuredClone(serverSolutionPricingItems);
  numberConnections = structuredClone(numberConnections);
  editorialBoard = structuredClone(editorialBoard);
  dynamicRows: string[];
  selectedItem: any = null;
  numberConnectionsOptions: { id: number; name: number; }[];
  screenWidth: number = window.innerWidth;
  screenHeight: number = window.innerHeight;
  widthFirstColumn: number | string;
  widthColumn: number | string;
  scrollPosition: { top: number; left: number } = { top: 0, left: 0 };
  isHeaderSticky: boolean = false;
  scrollbarHorizontal: boolean;
  protected readonly ColumnMode = ColumnMode;
  private elementRef: ElementRef<any> = inject(ElementRef);
  visibleRowsFiltered: ComparisonRow[];
  public comparisonLinks: {
    basic: string;
    freedom: string;
    business: string;
    corporation: string;
    corporationPlus: string;
    corporationPlusFstec: string
  };
  private needUpdateGridClasses = false;
  private previousSelectedItemsLength = -1;
  private previousVisibleUnitsLength = -1;
  private previousVisibleRowsLength = -1;
  private collapsedGroupsSize = -1;
  private radioFirstStateItems: InterfaceRadioEditorials[] = [];
  // private verifiableSelectedItems: number[] = [];

  constructor() {
    this.hasOneCheckboxChecked = false;
    this.radioItems = [];
    this.units = [];
    this.unitsClone = [];
    this.visibleUnits = [];
    this.dynamicRows = ['Стоимость', 'Количество одновременных управляющих соединений'];
    this.numberConnectionsOptions = [];
    this.widthFirstColumn = 273;
    this.widthColumn = 'auto';
    this.scrollbarHorizontal = false;
    this.comparisonLinks = {
      basic: '/скачать',
      freedom: '/обратная-связь?form=купить&connections=1&solution=Свобода',
      business: '/обратная-связь?form=купить&connections=3&solution=Бизнес',
      corporation: '/обратная-связь?form=купить&connections=5&solution=Корпорация',
      corporationPlus: '/обратная-связь?form=купить&connections=3&solution=Корпорация%20плюс',
      corporationPlusFstec: '/обратная-связь?form=купить&connections=3&solution=Корпорация%20плюс%20ФСТЭК',
    }
    this.visibleRowsFiltered = [];
  }

  ngOnInit() {
    this.units = [
      {
        id: 1, name: 'Базовая',
        field: 'basic',
        numberConnections: 1,
        indexConnections: null,
        isPro: false,
      },
      {
        id: 2, name: 'Свобода',
        field: 'freedom',
        numberConnections: 1,
        indexConnections: null,
        isPro: false,
      },
      { id: 3, name: 'Бизнес',  field: 'business', numberConnections: 3, indexConnections: null, isPro: false },
      { id: 4, name: 'Корпорация',  field: 'corporation', numberConnections: 5, indexConnections: null, isPro: false },
      {
        id: 5, name: 'Корпорация +',
        field: 'corporationPlus', numberConnections: 3,
        indexConnections: 0,
        isPro: true,
      },
      {
        id: 6,
        name: 'Корпорация + ФСТЭК',
        field: 'corporationPlusFstec',
        numberConnections: 3,
        indexConnections: 0,
        isPro: false,
      }
    ];
    this.selectedItems = [];
    this.radioItems = [
      {id: 1, name: 'Все возможности', isSelected: true},
      {id: 2, name: 'Только различия', isSelected: false},
    ];
    this.unitsClone = structuredClone(this.units);
    this.visibleUnits = this.unitsClone;
    this.numberConnectionsOptions = this.numberConnections.map((numberConnection: number, index: number) => {
      return {id: index, name: numberConnection}
    });
    this.checkScreenSize();
    this.widthFirstColumn = 273;
  }

  getRowClass = (row: any) => {
    let className = '';
    className  = row.isGroup ? 'merged-group-column'
      : (row.name === 'Количество управляющих устройств'
      || row.name === 'Лицензированные пользователи')
      ? 'merged-common-column' : ''
    return className;
  }

  // Методы для работы с селектом
  toggleDropdown(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.isOpen = !this.isOpen;
  }

  isSelected(item: any): boolean {
    return this.selectedItems.includes(item.id);
  }

  isAllSelected(): boolean {
    return this.selectedItems.length === this.units.length;
  }

  toggleItem(item: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    const index = this.selectedItems.indexOf(item.id);
    if (index === -1) {
      this.selectedItems.push(item.id);
    } else {
      this.selectedItems.splice(index, 1);
    }

    this.selectedItems = [...this.selectedItems];
    this.hasOneCheckboxChecked = this.selectedItems.length === 1
  }

  toggleSelectAll(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.selectedItems = checked
      ? this.units.map(item => item.id)
      : [];
  }

  clearAll(): void {
    this.selectedItems = [];
  }

  // Закрытие по клику вне
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.elementRef && this.elementRef.nativeElement) {
      const selectElement = this.elementRef.nativeElement.querySelector('[data-comparison-editions-select]');

      if (selectElement && !selectElement.contains(event.target as Node)) {
        this.isOpen = false;
      }
    }
  }

  onApplyEditions() {
    // if (this.verifiableSelectedItems.length !== this.selectedItems.length) { // оптимизация

      if (this.selectedItems.length > 0) {
        const visibleUnits = this.visibleUnits;
        this.visibleUnits = this.unitsClone.filter((visibleUnit: InterfaceEditorials) =>
          this.selectedItems.includes(visibleUnit.id));
        this.isOpen = !this.isOpen;
        this.visibleUnits.forEach((unit: InterfaceEditorials) => {
          const currentVisibleUnits = visibleUnits.find(visibleUnitChanged => visibleUnitChanged.id === unit.id);
          if (currentVisibleUnits) {
            unit.indexConnections = currentVisibleUnits.indexConnections;
          }
        });
        const unselectedUnits
          = this.unitsClone.filter(unit => !this.visibleUnits.some(visibleUnit => visibleUnit.id === unit.id));
        this.visibleRowsFiltered = structuredClone(this.rows);

        this.visibleRowsFiltered.forEach(visibleRows => {

          Object.keys(visibleRows).forEach(key => {
            if (unselectedUnits.some(unit => unit.field === key)) {
              delete (visibleRows as any)[key];
            }
          });
        });
        const radio = this.radioItems.find(radioItem => radioItem.isSelected);

        if (radio) {
          this.filterDifferences(radio);
        }
        // this.verifiableSelectedItems = structuredClone(this.selectedItems); // оптимизация
      }
    this.filtrationStyleClassesCleaning();
    // }
    // this.updateVisibleRows()
  }
  onApplyReset() {
    this.visibleUnits = this.unitsClone;
    this.visibleRows = structuredClone(this.rows);
    this.selectedItems = [];
    this.radioItems.forEach(radioItem => {
      radioItem.isSelected = false;
    });
    this.radioItems[0].isSelected = true;
    this.filtrationStyleClassesCleaning();
    this.visibleRowsFiltered = [];
    this.updateVisibleRows();
  }
  filtrationStyleClassesCleaning() {
    this.units.forEach((unit: InterfaceEditorials, index: number) => {
      const header = document.querySelector('.datatable-header')
      if (header) {
        const datatableRowCenter = header.querySelector('.datatable-row-center');
        if (datatableRowCenter) {
          datatableRowCenter.classList.remove(`datatable-row-center--grid-template-columns-${index + 1}`)
        }
      }
    });
  }
  onFilterDifferences(selectedRadio: InterfaceRadioEditorials) {
    this.filterDifferences(selectedRadio);
  }
  filterDifferences(selectedRadio: InterfaceRadioEditorials) {
    this.radioItems.forEach((item: InterfaceRadioEditorials) => {
      item.isSelected = item.id === selectedRadio.id;
    });
    const currentRows = this.visibleRowsFiltered.length > 0 ? this.visibleRowsFiltered : this.rows;
    if (selectedRadio.id === 2 && selectedRadio.isSelected) {
      this.visibleRows = currentRows.filter((row: ComparisonRow, index: number) => {
        const units = this.selectedItems.length > 0
          ? this.units.filter(unit => this.selectedItems.includes(unit.id))
          : this.units;

        const valueCellsInRow = units.map(unit => {
          if (Object.keys(row).indexOf(unit.field)) {
            const field = unit.field as keyof ComparisonRow;
            return row[field];
          }
        });

        return (currentRows.length === index + 1 || row.isGroup)
          ? true
          : !valueCellsInRow.every(cell => valueCellsInRow[0] === cell);
      });
    } else {
      this.visibleRows = [...currentRows];
      this.updateVisibleRows();
    }
  }
  ngAfterViewChecked() {
    if (!this.tableEl?.nativeElement) {
      return;
    }
    // const equals = (a: InterfaceRadioEditorials[], b: InterfaceRadioEditorials[]) => a.length // оптимизация
    //   === b.length && a.every((v: InterfaceRadioEditorials, i: number) => v.id
    //   === b[i].id && v.isSelected === b[i].isSelected);
    // const hasChanges = this.previousSelectedItemsLength !== this.selectedItems.length ||
    //   this.previousVisibleUnitsLength !== this.visibleUnits.length ||
    //   this.previousVisibleRowsLength !== this.visibleRows.length ||
    //   this.collapsedGroupsSize !== this.collapsedGroups.size ||
    //   !equals(this.radioFirstStateItems, this.radioItems)
    // if (!hasChanges && !this.needUpdateGridClasses) {
    //   return;
    // }
    // this.previousSelectedItemsLength = this.selectedItems.length;
    // this.previousVisibleUnitsLength = this.visibleUnits.length;
    // this.previousVisibleRowsLength = this.visibleRows.length;
    // this.collapsedGroupsSize = this.collapsedGroups.size;
    // this.radioFirstStateItems = structuredClone(this.radioItems);
    // this.needUpdateGridClasses = false;

    // requestAnimationFrame(() => {
    //   this.updateGridClasses();
    // });
    this.updateGridClasses();
  }

  private updateGridClasses() {
    if (!this.tableEl?.nativeElement) {
      return;
    }
    const datatableRowCenterItems: HTMLElement[] = Array.prototype.slice.call(
      this.tableEl.nativeElement.querySelectorAll('.datatable-row-center')
    );
    if (datatableRowCenterItems.length === 0) {
      return;
    }
    const shouldUpdate = this.visibleUnits.length === this.selectedItems.length ||
      this.selectedItems.length === 0;

    if (shouldUpdate) {
      datatableRowCenterItems.forEach((datatableRowCenterItem: HTMLElement) => {
        this.unitsClone.forEach((unit: InterfaceEditorials, index: number) => {
          datatableRowCenterItem.classList
            .remove(`datatable-row-center--grid-template-columns-${index}`);
        });
        if (this.selectedItems.length !== 0) {
          datatableRowCenterItem.classList
            .add(`datatable-row-center--grid-template-columns-${this.selectedItems.length}`);
        }
      });
    }
  }

  onKnowPrice(column: TableColumn, numberConnection: number) {

    const unit = this.visibleUnits.find((unit: InterfaceEditorials) => unit.field === column.prop)
    if (unit) {
      unit.indexConnections = numberConnections.indexOf(numberConnection);
      this.setComparisonLinks(numberConnections[unit.indexConnections], column);
    }
  }
  toggleGroup(event: Event, groupRow: ComparisonRow) {
    const eventTarget = event.target as HTMLElement;
    if (!eventTarget.closest('[data-hint]')) {
      if (this.collapsedGroups.has(groupRow.id)) {
        this.collapsedGroups.delete(groupRow.id);
      } else {
        this.collapsedGroups.add(groupRow.id);
      }

      this.updateVisibleRows();
    }
  }
  updateVisibleRows() {
    this.visibleRows = structuredClone(this.rows).filter(row => {
      if (!row.parentId) return true;

      return !this.collapsedGroups.has(row.parentId);
    });
  }
  onEditionSelected(item: {id: number; name: number}, column: any) {
    const unit = this.visibleUnits.find((unit: InterfaceEditorials) => unit.field === column.prop);
    if (unit) {
      unit.indexConnections = numberConnections.indexOf(item.name);
      this.setComparisonLinks(numberConnections[unit.indexConnections], column)
    }
  }
  setComparisonLinks(numberConnection: number, column: TableColumn) {
    if (column) {
      const columnName = column?.name?.replace("+", "плюс");
      if (column.prop && columnName) {
        this.comparisonLinks[column.prop as keyof typeof this.comparisonLinks]
          = `/обратная-связь?form=купить&connections=${numberConnection}&solution=${columnName}`;
      }
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    this.checkScreenSize();
  }
  checkScreenSize() {
    // Изменяем переменные в зависимости от ширины экрана

    if (this.screenWidth <= 1280) {
      this.widthFirstColumn = 180;
    }
    if (this.screenWidth <= 780) {
      this.widthFirstColumn = 'auto'
    }
    if (this.screenWidth <= 1380) {
      this.widthFirstColumn = 200;
    }
    if (this.screenWidth <= 1080) {
      this.widthFirstColumn = 150;
    }
    if (this.screenWidth <= 1280) {
      this.widthColumn = 120;
    }
    if (this.screenWidth <= 980) {
      this.widthColumn = 80;
    }
    if (this.screenWidth <= 790) {
      this.widthColumn = 70;
      this.scrollbarHorizontal = true
    }
  }
  onScroll(event: Event): void {
    const element = event.target as HTMLElement;
    this.scrollPosition = {
      top: element.scrollTop,
      left: element.scrollLeft
    };

    const header = document.querySelector('.advanced-table .datatable-header');
    if (header) {
      if (this.scrollPosition.top > 10) {
        header.classList.add('sticky-shadow');
      } else {
        header.classList.remove('sticky-shadow');
      }
    }

    // Добавляем класс для индикации горизонтального скролла
    if (this.scrollPosition.left > 10) {
      element.classList.add('horizontal-scrolled');
    } else {
      element.classList.remove('horizontal-scrolled');
    }
  }
  numberToLocaleString(cellValue: string | number): string | number {
    if (typeof cellValue === 'boolean') {
      return cellValue
        ? `
            <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3912 0.796919C18.5926 1.03945 18.75 1.32463 18.8543 1.63618C18.9586 1.94773 19.0078 2.27954 18.999 2.61265C18.9903 2.94577 18.9237 3.27366 18.8033 3.57761C18.6828 3.88155 18.5108 4.15559 18.2969 4.38408L8.07898 15.3095C7.65199 15.7659 7.08401 16.0137 6.4975 15.9994C5.91098 15.9851 5.35291 15.7098 4.94362 15.233L0.633786 10.2094C0.22011 9.72719 -0.00779621 9.07827 0.000203712 8.40541C0.00820364 7.73254 0.251455 7.09083 0.676444 6.62146C1.10143 6.15209 1.67335 5.8935 2.26638 5.90258C2.8594 5.91165 3.42496 6.18765 3.83864 6.66986L6.61347 9.90416L15.2311 0.690748C15.6626 0.229269 16.2381 -0.0187983 16.8309 0.00111232C17.4236 0.0210229 17.9844 0.307281 18.3912 0.796919Z" fill="#02B51D"/>
            </svg>
            `
        : `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.7262 0.585528C15.5072 1.36654 15.5071 2.63292 14.7262 3.41396L10.4877 7.65245L14.7386 11.9034C15.5196 12.6844 15.5196 13.9508 14.7386 14.7318C13.9575 15.5128 12.6912 15.5128 11.9102 14.7318L7.65923 10.4809L3.41244 14.7277C2.6314 15.5085 1.36499 15.5086 0.584018 14.7277C-0.196934 13.9467 -0.196817 12.6803 0.584018 11.8992L4.8308 7.65245L0.597138 3.41879C-0.183864 2.63779 -0.183807 1.3714 0.597138 0.590362C1.37817 -0.190669 2.64453 -0.190669 3.42557 0.590362L7.65923 4.82403L11.8977 0.585528C12.6788 -0.195433 13.9451 -0.195467 14.7262 0.585528Z" fill="#EE1B2B"/>
            </svg>
          `;
    } else {
      if (cellValue && typeof cellValue !== 'string') {
        return `<h6>${cellValue.toLocaleString('ru')}</h6>`;
      } else {
        return  `<h6>${cellValue}</h6>`;
      }
    }
  }
}

@NgModule({
  declarations: [
    AppComponent,
    ComparisonEditionsSelectComponent,
    EscapeHtmlPipe,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    NgxDatatableModule,
    TippyDirective,
  ],
  // providers:[
  //   ComparisonEditionsSelectComponent
  // ],
  providers: [
    provideTippyLoader(() => tippy),
    provideTippyConfig({
      defaultVariation: 'tooltip',
      variations: {
        tooltip: tooltipVariation,
        popper: popperVariation,
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}

export class ComparisonEditionsPage {
  constructor() {}
  public initialize(): void {
    platformBrowserDynamic().bootstrapModule(AppModule);
  }
}
